(() => {
  const SELECTOR = '[data-cch="legacy"][data-cch-parallax="true"] .parallax';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initParallax(container) {
    if (!container || container.dataset.cchBound === 'true') return;
    container.dataset.cchBound = 'true';

    const items = Array.from(container.querySelectorAll('.parallax'));
    if (!items.length) return;

    // Cache inner nodes to avoid repeated queries on scroll
    const entries = items.map((el) => ({
      el,
      speed: parseFloat(el.getAttribute('speed')) || 1,
      content: el.querySelector('.parallax-content'),
      top: 0
    })).filter(x => x.content);

    if (!entries.length) return;

    let ticking = false;
    let rafId = null;

    const measure = () => {
      entries.forEach((x) => {
        const rect = x.el.getBoundingClientRect();
        x.top = rect.top + window.scrollY;
      });
    };

    const update = () => {
      ticking = false;
      const scrollY = window.scrollY || window.pageYOffset || 0;

      for (const x of entries) {
        if (!x.content) continue;
        if (x.top < scrollY) {
          const diff = scrollY - x.top;

          // Legacy behavior was diff/2. Keep 1/1 look.
          // "speed" stays supported: speed=1 => 0.5 factor.
          const y = diff * 0.5 * x.speed;

          x.content.style.transform = `translate3d(0, ${y}px, 0)`;
        } else {
          x.content.style.transform = 'translate3d(0,0,0)';
        }
      }
    };

    const requestTick = () => {
      if (ticking) return;
      ticking = true;
      rafId = window.requestAnimationFrame(update);
    };

    const onScroll = () => requestTick();
    const onResize = () => {
      measure();
      requestTick();
    };

    // Don’t animate for reduced motion users
    if (prefersReducedMotion()) {
      measure();
      update();
      return;
    }

    // Only run while header exists (no heavy observers needed)
    measure();
    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    // Cleanup hook if you ever want to detach (optional)
    container._cchCleanup = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      if (rafId) cancelAnimationFrame(rafId);
      container.dataset.cchBound = 'false';
    };
  }

  function boot() {
    const containers = document.querySelectorAll('[data-cch="legacy"][data-cch-parallax="true"]');
    containers.forEach(initParallax);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // In case theme re-renders parts (safe re-run)
  document.addEventListener('shopify:section:load', boot);
})();
